<template>
    <!-- ========== PLACES ========== -->
    <section id="places" v-if="gallery != null && gallery.photos != undefined">
        <div class="container">
            <div class="main_title mt_wave a_center">
                <h2 v-lang.gallery class="uppercase"></h2>
            </div>
            <p class="main_description a_center" v-show="false">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit.</p>
            <div class="row">
                <!-- ITEM -->
                <div class="col-md-3 col-sm-3" v-for="photo in gallery.photos">
                    <item-place v-bind:src="photo.large" title=""></item-place>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ItemPlace from './ItemPlace.vue';
    export default {
        data : function(){
            return {
                gallery : null
            }
        },
        components : {
            'item-place' : ItemPlace
        },
        created : function(){
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( !_.isNull(self.$store.getters.config) )
                {
                    self.gallery = self.$store.getters.config.gallery;
                }
            });
        },
        mounted : function()
        {
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config)  )
            {
                self.gallery = self.$store.getters.config.gallery;
            }
        },
        beforeDestroy : function(){
            this.unsubscribe();
        }
    }
</script>


// WEBPACK FOOTER //
// Places.vue?20c78128